// Action Types
export const SAVE_PAGE_VISIT_LOGS = "weblogs/SAVE_PAGE_VISIT_LOGS";
export const SAVE_PAGE_VISIT_LOGS_SUCCESS =
  "weblogs/SAVE_PAGE_VISIT_LOGS_SUCCESS";
export const SAVE_PAGE_VISIT_LOGS_FAILED =
  "weblogs/SAVE_PAGE_VISIT_LOGS_FAILED";
export const GET_PAGE_VISIT_LOGS = "weblogs/GET_PAGE_VISIT_LOGS";
export const GET_PAGE_VISIT_LOGS_SUCCESS =
  "weblogs/GET_PAGE_VISIT_LOGS_SUCCESS";
